export const FETCH_PREVIEW = 'COORDINATOR.QUESTIONNAIRE.FETCH_PREVIEW';
export const CLEAR_PREVIEW = 'COORDINATOR.QUESTIONNAIRE.CLEAR_PREVIEW';
